<template>
  <header class="app-bar">
    <div class="app-bar__inner">
      <router-link to="/home" class="brand">
        <span class="brand__mark" aria-hidden="true"></span>
        <span class="brand__name">足彩助手</span>
      </router-link>
      <a-menu
        v-model:selectedKeys="selectedKeys"
        theme="light"
        mode="horizontal"
        class="app-nav"
      >
        <a-menu-item key="Home">
          <router-link to="/home">我要下注</router-link>
        </a-menu-item>
        <a-menu-item key="MyOdds">
          <router-link to="/MyOdds">下注历史</router-link>
        </a-menu-item>
        <a-menu-item key="Verify" v-if="userId == 1">
          <router-link to="/Verify">测算法</router-link>
        </a-menu-item>
        <a-menu-item key="Stats">
          <router-link to="/Stats">统计</router-link>
        </a-menu-item>
        <a-menu-item key="Settings">
          <router-link to="/settings">设置</router-link>
        </a-menu-item>
      </a-menu>
    </div>
  </header>
</template>

<script>
export default {
  data() {
    return {
      selectedKeys: [this.$route.name]
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(newRoute) {
        this.selectedKeys = [newRoute.name || newRoute.matched[0]?.name];
      }
    }
  },
  computed: {
    userId() {
      return localStorage.getItem('userId')
    }
  },
  methods: {
    logout() {
      localStorage.removeItem('isLoggedIn');
      this.$router.push('/');
    },
  }
};
</script>

<style scoped>
.app-bar {
  background: var(--surface);
  border-bottom: 1px solid var(--line);
  position: sticky;
  top: 0;
  z-index: 30;
}

.app-bar__inner {
  max-width: 1040px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: center;
  gap: 24px;
  min-height: 60px;
}

.brand {
  display: inline-flex;
  align-items: center;
  gap: 9px;
  font-size: 19px;
  font-weight: 700;
  color: var(--pitch-900);
  white-space: nowrap;
  text-decoration: none;
}
.brand:hover { color: var(--pitch-700); }

/* a tiny "pitch" mark: green disc with a centre line */
.brand__mark {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  background: var(--pitch-600);
  position: relative;
  flex: none;
}
.brand__mark::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 3px;
  bottom: 3px;
  width: 2px;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, .7);
}
.brand__mark::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, .7);
  transform: translate(-50%, -50%);
}

/* Ant menu sits flush at the bottom of the bar so the active
   underline aligns with the bar's hairline */
.app-nav {
  flex: 1;
  border-bottom: none;
  line-height: 58px;
  background: transparent;
}

@media (max-width: 640px) {
  .app-bar__inner {
    flex-direction: column;
    align-items: stretch;
    gap: 0;
    padding: 0 12px;
  }
  .brand {
    min-height: 52px;
  }
  .app-nav {
    line-height: 44px;
    display: flex;
    flex-wrap: wrap;
    border-top: 1px solid var(--line);
  }
}
</style>
